import Vue from 'vue'

import CoolLightBox from 'vue-cool-lightbox'

Vue.component('CoolLightBox', CoolLightBox)
